<template>
  <form class="space-y-6" novalidate @submit="onFormSubmit">
    <FormInputText
      name="email"
      type="email"
      autocomplete="email"
      label="Email Address"
    />

    <div class="flex justify-end">
      <FormSubmitButton :is-loading="isSubmitting">
        Email access link
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import { z } from "zod"
import { emailAddressSchema } from "@/validation/sharedStringFieldSchemas"

const formSchema = z.object({
  email: emailAddressSchema("Email is required"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
  },
})

const onFormSubmit = handleSubmit(async (values) => {
  try {
    await requestLogInLink(values)
    toast.success(
      "If an active account was found, a login link has been sent to the requested email address",
      5000
    )
  } catch {
    toast.error("Something went wrong")
  }
})
</script>
